import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { Stack } from '@chakra-ui/react'

import { CustomFormQuestion, CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { hourMask } from 'utils/masks'
import { validateHour } from 'utils/validation/validators'

import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'

type Props = {
  label: string
  registerKey: string
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function HourFieldWithValidator({ formMethods, label, registerKey }: Props) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const handleValidateHour = (hour: string): boolean => {
    let initialValue = { isValid: true, message: '' }
    if (hour && !validateHour(hour)) {
      initialValue = { isValid: false, message: 'Horário está errado' }
    }
    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  return (
    <Stack>
      <FormItem label={label}>
        <MaskedInput
          mask={hourMask}
          {...formMethods.register(registerKey, {
            validate: handleValidateHour,
          })}
        />
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />
    </Stack>
  )
}
